import { Component, OnInit, inject } from '@angular/core';
import {faEdit, faUsers, faToolbox, faVideo, faQuestion, faProjectDiagram, faFile, faCalendar, faQuoteLeft, faUserGraduate, faBuilding, faHospitalUser, faTachometerAlt, faFileContract, faLightbulb, faGraduationCap, faSchool, faTags} from '@fortawesome/free-solid-svg-icons';
import { UserService } from '../../shared/services/user.service';

@Component({
    selector: 'app-admin-side-navigation',
    templateUrl: './admin-side-navigation.component.html',
    styleUrls: ['./admin-side-navigation.component.scss'],
    standalone: false
})
export class AdminSideNavigationComponent implements OnInit {

  private readonly userService = inject(UserService);

  /**
   * Companies menu is visible for every admin role (Beheerder,
   * ProfessionalAdmin, InternationalAdmin). The list page itself picks the
   * right endpoint per role: Beheerder hits /company/all, the sub-admins hit
   * the regular /company which they are allowed to GET.
   */
  readonly canManageCompanies = this.userService.currentUserIsAdmin();

  // Icons
  faEdit = faEdit;
  faUsers = faUsers;
  faVideo = faVideo;
  faProjectDiagram = faProjectDiagram;
  faFile = faFile;
  faCalendar = faCalendar;
  faQuoteLeft = faQuoteLeft;
  faUserGraduate = faUserGraduate;
  faBuilding = faBuilding;
  faHospitalUser = faHospitalUser;
  faTachometerAlt = faTachometerAlt;
  faFileContract = faFileContract;
  faLightbulb = faLightbulb;
  faGraduationCap = faGraduationCap;
  faQuestion = faQuestion;
  faSchool = faSchool;
  faToolbox = faToolbox;
  faTags = faTags;

  constructor() { }

  ngOnInit(): void {
  }

}
